import { Accordion, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";
import { useState } from "react";

import { LocaleSelect } from "~/features/headerV3/components/LocaleSelect";
import { NavbarItem } from "~/features/headerV3/components/NavbarItem";
import { TopHeaderButton } from "~/features/headerV3/components/TopHeaderButton";
import { UserLogin, UserLogout } from "~/icons";

import type { HeaderProps } from "../HeaderV3";

export const TopHeaderComponent: FC<HeaderProps> = ({
  data,
  clickHeaderMain,
  clickHeaderSub,
  onCallAction,
  isActionInactive,
  getUrl,
}) => {
  const [currentPage, setCurrentPage] = useState<string>("");

  const onNavlinkClick = (url: string, id: string): void => {
    clickHeaderMain(url);
    setCurrentPage(id);
  };

  return (
    <Flex
      p={{ py: 12, px: 40 }}
      justify="space-between"
      align="center"
      width="100%"
      maxHeight={48}
      display="hidden"
      d={{ display: "flex" }}
      bg="background-secondary"
      data-testid="header-top"
    >
      {data?.languages && (
        <>
          <Flex width="100%" align="center">
            {data?.top_menu?.action_items && (
              <Accordion>
                {data.top_menu.action_items
                  ?.filter((action) => {
                    if (action?.menu_action_items_id?.action) {
                      return !isActionInactive(
                        action.menu_action_items_id.action,
                      );
                    }

                    return true;
                  })
                  ?.map(
                    (item, index) =>
                      item?.menu_action_items_id && (
                        <Flex
                          width="100%"
                          md={{ width: "100%" }}
                          d={{
                            width: "auto",
                            display: "flex",
                          }}
                          key={item?.menu_action_items_id.id}
                          display="hidden"
                          m={{ mr: 24 }}
                          data-testid={`header-top-nav-item-${index}`}
                        >
                          <NavbarItem
                            {...item.menu_action_items_id}
                            currentNavlink={currentPage}
                            onNavlinkClick={onNavlinkClick}
                            clickHeaderSub={clickHeaderSub}
                            getUrl={getUrl}
                            onCallAction={onCallAction}
                            offset={14}
                          />
                        </Flex>
                      ),
                  )}
              </Accordion>
            )}
          </Flex>
          <Flex justify="end" align="center" gap={24}>
            {data?.top_additional_menu?.action_items
              ?.filter((action) => {
                if (action?.menu_action_items_id?.action) {
                  return !isActionInactive(action.menu_action_items_id.action);
                }

                return true;
              })
              ?.map((item) => {
                const topHeaderButtonIcon =
                  item?.menu_action_items_id?.action?.inactive_if?.includes(
                    "unauthorized",
                  ) ? (
                    <UserLogout className="mr-1" />
                  ) : item?.menu_action_items_id?.action?.inactive_if?.includes(
                      "authorized",
                    ) ? (
                    <UserLogin className="mr-1" />
                  ) : null;

                return (
                  <TopHeaderButton
                    icon={topHeaderButtonIcon}
                    key={item?.id}
                    size="small"
                    weight="bold"
                    item={item?.menu_action_items_id}
                    getUrl={getUrl}
                    onCallAction={onCallAction}
                  />
                );
              })}
            {data.language_selector_position === "top-menu" &&
              data.languages && (
                <LocaleSelect
                  {...data}
                  isNonModal={false}
                  languages={data.languages}
                  variant="positioned"
                  offset={4}
                />
              )}
          </Flex>
        </>
      )}
    </Flex>
  );
};
